import { ActuatorDescriptionsDto } from '../../dto/smart-home.dto'
import { ActuatorDescriptions } from '../../models/smart-home.model'

export const actuatorDescriptionsModelToDtoTransformer = (model: Partial<ActuatorDescriptions>): ActuatorDescriptionsDto => {
  const descriptionsTransformed: ActuatorDescriptionsDto = {
    S10: model.s10,
    SINGLE: model.single,
    GROUP: model.group,
    TimeOn: model.timeOn,
    TimeOff: model.timeOff,
    SOCOn: model.socOn?.toString(),
    SOCOff: model.socOff?.toString(),
    minOn: model.minOn,
    minOff: model.minOff,
    usedPower: typeof model.usedPower === 'number' ? model.usedPower.toString() : model.usedPower,
    refSource: model.refSource,
    refPM: model.refPM,
    refTH: model.refTH,
    refMax: model.refMax,
    refStart: model.refStart,
    Week: model.week,
    Auto: model.auto ? '1' : '0',
  }

  return Object.fromEntries(Object.entries(descriptionsTransformed).filter(([_, value]) => value !== undefined)) as ActuatorDescriptionsDto
}
